import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import BackgroundAnimations from "./BackgroundAnimations";

const manifestoLines = [
  "We believe capital is freedom.",
  "",
  "It powers ideas, builds legacies, and drives human progress.",
  "",
  "But today's markets are closed, fragmented, and slow.",
  "",
  "We are here to change that. Shape the market, not follow it.",
  "",
  "A simple and efficient investment infrastructure, built for the restless by the restless.",
  "",
  "We exist for institutions that believe that the future of capital markets is open, interoperable and frictionless at a global scale.",
  "",
  "We are Veltiz.",
  "",
  "Break the frontiers.",
];

export default function ManifestoSection() {
  const ref = useRef<HTMLDivElement>(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });

  const opacity = useTransform(scrollYProgress, [0, 0.2, 0.8, 1], [0, 1, 1, 0]);
  const y = useTransform(scrollYProgress, [0, 0.2, 0.8, 1], [100, 0, 0, 100]);

  return (
    <section
      ref={ref}
      className="min-h-screen py-20 md:py-32 px-4 md:px-6 bg-background relative overflow-hidden flex flex-col justify-center"
    >
      <BackgroundAnimations scrollYProgress={scrollYProgress} />

      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/3 right-1/3 w-96 h-96 rounded-full bg-primary/5 blur-[100px]" />
      </div>

      <motion.div style={{ opacity, y }} className="container max-w-4xl mx-auto relative z-10">
        <h2 className="text-3xl md:text-5xl font-bold mb-16 text-center">Our Manifesto</h2>

        <div className="space-y-4 text-center">
          {manifestoLines.map((line, index) => (
            <motion.p
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.05 }}
              viewport={{ once: true, margin: "-100px" }}
              className={[
                "text-xl md:text-2xl",
                index === 0 || line === "Break the frontiers."
                  ? "font-bold text-foreground"
                  : line === "We are Veltiz."
                  ? "text-muted-foreground italic"
                  : line === ""
                  ? "h-2"
                  : "text-muted-foreground",
              ]
                .filter(Boolean)
                .join(" ")}
            >
              {line}
            </motion.p>
          ))}
        </div>
      </motion.div>
    </section>
  );
}
